import { ApiVersions } from '../api-versions';
import type { GetMetricGroupOpenAPIQueryParams } from '../generated/operations/raw-openapi-query-params-for-serializers';

export const apiVersion = ApiVersions.Beta;

export interface GetMetricGroupQueryParams extends Omit<GetMetricGroupOpenAPIQueryParams, 'expand'> {
  expand?: Array<
    | 'experiments'
    | 'experimentCount'
    | 'guardedRolloutCount'
    | 'guardedRollouts'
    | 'lastUsedInExperiment'
    | 'lastUsedInGuardedRollout'
    | 'activeGuardedRolloutCountByEnv'
    | 'activeExpCountByEnv'
    | 'releasePolicies'
    | 'releasePolicyCount'
  >;
}

export function querySerializer(queryParams: GetMetricGroupQueryParams) {
  const searchParams = new URLSearchParams();

  if (queryParams.expand && queryParams.expand.length > 0) {
    searchParams.set('expand', queryParams.expand.join(','));
  }

  return searchParams.toString();
}
